




import React from "react";
import ClipLoader from "react-spinners/ClipLoader";

const DottedCircleLoader = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <ClipLoader
        color="#12B886"
        size={48}
        speedMultiplier={1.2}
        cssOverride={{ marginBottom: '2rem' }}
      />
      <span className="text-xl font-semibold text-gray-800 dark:text-gray-100 tracking-wide drop-shadow-sm">Loading candidates...</span>
    </div>
  );
};

export default DottedCircleLoader;
